import React, { useRef } from "react";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import "../../../styles/ContactStyle.css";

import EmailJsConfig from "../../../Helpers/EmailJsConfig";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import "../../../styles/ContactStyle.css";

const ContactForm = () => {
  //Data
  const initialValues = {
    from_name: "Contact Form",
    name: "",
    email: "",
    contact_number: "",
    subject: "",
    message: "",
  };

  //Phone No. validation
  const numericRegEx = /(?=.[0-9])/;
  const lengthRegEx = /(?=.{10,})/;

  //validation schema
  let validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    contact_number: Yup.string()
      .matches(numericRegEx, "Must contain only Numbers!")
      .matches(lengthRegEx, "Must contain 10 Digits!")
      .required("Required!"),
  });

  const form = useRef();

  function SendEmail(e) {
    emailjs
      .sendForm(
        EmailJsConfig.SERVICE_ID,
        EmailJsConfig.TEMPLATE_ID_ContactForm,
        form.current,
        EmailJsConfig.USER_ID
      )
      .then(
        (result) => {
          console.log(result.text);
          Swal.fire({
            icon: "success",
            title: "Message Sent Successfully",
            confirmButtonColor: "black",
          });
        },
        (error) => {
          console.log(error.text);
          Swal.fire({
            icon: "error",
            title: "Ooops, something went wrong",
            text: error.text,
            confirmButtonColor: "red",
          });
        }
      );
  }

  const onSubmit = (values, formicHelpers) => {
    console.log("Form Values being sent in mail: ", values);
    SendEmail(values);
    formicHelpers.resetForm();
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ dirty, isValid, values, handleChange, handleBlur }) => {
        return (
          <Form ref={form} name="formName">
            <input name="from_name" defaultValue={values.from_name} hidden />

            <div className="row">
              <div className="col-md-12 form-group">
                <label className="input w-100">
                  <input
                    className="form-control"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    type="text"
                    placeholder="Name"
                  />
                </label>
              </div>

              <div className="col-md-12 form-group">
                <label className="input w-100">
                  <input
                    className="form-control"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    type="text"
                    placeholder="Email"
                  />
                </label>
              </div>

              <div className="col-md-12 form-group">
                <label className="input w-100">
                  <input
                    className="form-control"
                    name="subject"
                    value={values.subject}
                    onChange={handleChange}
                    type="text"
                    placeholder="Subject"
                  />
                </label>
              </div>

              <div className="col-md-12 form-group">
                <label className="input w-100">
                  <input
                    className="form-control"
                    name="contact_number"
                    value={values.contact_number}
                    onChange={handleChange}
                    type="text"
                    placeholder="Contact Number"
                  />
                </label>
              </div>

              <div className="col-md-12 form-group">
                <label className="input w-100">
                  <textarea
                    className="form-control"
                    name="message"
                    value={values.message}
                    onChange={handleChange}
                    type="text"
                    id="message"
                    cols="30"
                    rows="7"
                    placeholder="Type your message"
                  ></textarea>
                </label>
              </div>
            </div>

            {/* <div>
              <p
                sx={{
                  fontFamily: "Roboto-Regular !important",
                  fontSize: { xs: 10, md: 12 },
                  fontWeight: 800,
                  color: "black",
                  ml: { xs: 2, md: 0.5 },
                  textTransform: "capitalize !important",
                  zIndex: 2,
                  mt: "1rem",
                  textAlign: "justify",
                  display: "flex",
                  alignItems: "center",
                }}
                variant="h6"
                component="h2"
              >
                <span
                  style={{
                    color: "red",
                    fontSize: 20,
                    fontFamily: "Roboto-Bold !important",
                    fontWeight: 900,
                    marginRight: "0.3rem",
                  }}
                >
                  *
                </span>
                FormWarning
              </p>
            </div> */}
            <button
              className="btn btn-primary rounded-0 py-2 px-4"
              disabled={!dirty || !isValid}
              type="Submit"
            >
              Send Message
            </button>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ContactForm;
